import React from 'react';
import logo from './logo-light.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <a href={"https://timwheeler.com?ref=wheeler-holdings"} rel={"noreferrer"} target={"_blank"}>
          <img src={logo} className="App-logo" alt="logo"/>
        </a>
      </header>
    </div>
  );
}

export default App;
